import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysSupplier } from '../queryKeys';

import { deleteSupplierContact } from './deleteSupplierContact';
import { type DeleteSupplierContactMutationOptions } from './types';

/**
 * React Query based custom hook for deleting a contact from a supplier.
 *
 * Invalidates the supplier detail query for the affected data exchange ID on settle.
 *
 * @param options - Optional mutation options.
 * @returns The mutation result.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/delete_supplier_contact_suppliers_details__de_id__contacts__contact_id__delete
 */
export const useMutationDeleteSupplierContact = (
  options?: DeleteSupplierContactMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ deId, contactId }) =>
      deleteSupplierContact(deId, contactId),
    onSettled(_data, _error, { deId }) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysSupplier.getDetail(deId),
      });
    },
    throwOnError: false,
    ...options,
  });
};
